module.exports = __webpack_public_path__ + "site/img/88.098d5b7f.jpg";